import { useEffect, useRef } from "react";
import {
  selectIsConnectedToRoom,
  selectPermissions,
  useHMSActions,
  useHMSStore,
  useRecordingStreaming,
} from "@100mslive/react-sdk";
import { toast } from "sonner";

export const RECORDING_RESOLUTION = { width: 1920, height: 1080 };

/**
 * When the platform says the interview is recorded, asks 100ms for a 1080p
 * browser recording once the participant is in the room, unless one is
 * already running. Every participant allowed to record asks; whoever comes
 * second gets "already running", which is expected and not shown.
 *
 * meetingURL stays empty, as it always has: 100ms then records its default
 * view of the room. Changing it changes what every recording contains, so
 * it is a product decision (inventory 15.4).
 */
export function useAutoRecording(recordingEnabled) {
  const hmsActions = useHMSActions();
  const isConnected = useHMSStore(selectIsConnectedToRoom);
  const permissions = useHMSStore(selectPermissions);
  const { isBrowserRecordingOn } = useRecordingStreaming();
  const requested = useRef(false);

  useEffect(() => {
    if (
      !recordingEnabled ||
      !isConnected ||
      !permissions?.browserRecording ||
      isBrowserRecordingOn ||
      requested.current
    ) {
      return;
    }
    requested.current = true;
    hmsActions
      .startRTMPOrRecording({
        meetingURL: "",
        resolution: RECORDING_RESOLUTION,
        record: true,
      })
      .catch(error => {
        const message = error?.message || "";
        if (!message.includes("already running")) {
          toast.error("The recording could not start", {
            description: message,
          });
        }
      });
  }, [
    recordingEnabled,
    isConnected,
    permissions,
    isBrowserRecordingOn,
    hmsActions,
  ]);
}
